import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'proptypes';
import { API, Auth } from 'aws-amplify';
import { grabPrimaryName, scroller } from 'ux-helpers';
import Passport from './../forms/Passport';
import Visa from './../forms/Visa';
import Itinerary from './../forms/Itinerary';
import Insurance from './../forms/Insurance';
// import MedicalInformation from "../../lib/forms/MedicalInformation";
import TermsAndConditions from '../../lib/forms/TermsAndConditions';
import TermsAndConditionsModal from '../../lib/forms/TermsAndConditionsModal';
import LiabilityModal from '../../lib/forms/LiabilityModal';
import ItineraryModal from '../../lib/forms/ItineraryModal';
import InsuranceModal from '../../lib/forms/InsuranceModal';
import PassportModal from '../../lib/forms/PassportModal';
import ScubaModal from '../../lib/forms/ScubaModal';
import VisaChecklistModal from '../../lib/forms/VisaChecklistModal';
import EmergencyContact from '../../lib/forms/EmergencyContact';
import PadiScuba from '../../lib/forms/PadiScuba';
import AdditionalInformation from '../../lib/forms/AdditionalInformation';
import { Validators, FormBuilder } from 'react-reactive-form';
import { readableResponseMessage } from 'ux-helpers';

import './DocumentsAccordion.scss';

const publicIp = require('public-ip');

export default class DocumentsAccordion extends Component {
  state = {
    id: this.props.trip.id,
    mailingCountry: this.props.user.mailingCountry,
    destination: this.props.trip.destination,
    endDate: this.props.trip.endDate,
    startDate: this.props.trip.startDate,
    allDocuments: '',
    termsDocumentId: '',
    liabilityDocumentId: '',
    flightStatus: this.props.trip.tripFlightStatus,
  };

  componentDidMount() {
    Auth.currentSession().then(user => {
      this.setState({
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          'Content-Type': 'application/json',
        },
      });
      const options = { headers: this.state.headers };

      window.setTimeout(() => {
        publicIp
          .v4()
          .then(resp => {
            this.setState({
              ip: resp,
            });
          })
          .catch(error => {
            // IP Address Not Found
          });
      }, 1000);

      API.get('give-api', `/documents/${this.state.id}/`, options)
        .then(response => {
          if (
            this.state.mailingCountry === 'United States' &&
            grabPrimaryName(this.state.destination) === 'Nicaragua'
          ) {
            this.setState({
              allDocuments:
                (this.state.mailingCountry === 'United States' &&
                  this.state.destination === 'WILD: Pacific Northwest') ||
                (this.state.mailingCountry === 'United States' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua PKG')
                  ? {
                      ...response.documents,
                      ...response.documents.documents,
                      visa: { status: 'No Visa Needed Based on Citizenship' },
                    }
                  : response.documents,
            });
          } else {
            this.setState({
              allDocuments:
                (this.state.mailingCountry === 'United States' &&
                  this.state.destination === 'WILD: Pacific Northwest') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua PKG')
                  ? {
                      ...response.documents,
                      ...response.documents.documents,
                      passport: { status: 'Not Required Based on Citizenship' },
                      visa: { status: 'No Visa Needed Based on Citizenship' },
                    }
                  : response.documents,
            });
          }
        })
        .catch(() => {
          if (
            this.state.mailingCountry === 'United States' &&
            grabPrimaryName(this.state.destination) === 'Nicaragua'
          ) {
            this.setState({
              allDocuments:
                (this.state.mailingCountry === 'United States' &&
                  this.state.destination === 'WILD: Pacific Northwest') ||
                (this.state.mailingCountry === 'United States' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua PKG')
                  ? {
                      ...this.state.allDocuments,
                      ...this.state.allDocuments.documents,
                      visa: { status: 'No Visa Needed Based on Citizenship' },
                    }
                  : {},
            });
          } else {
            this.setState({
              allDocuments:
                (this.state.mailingCountry === 'United States' &&
                  this.state.destination === 'WILD: Pacific Northwest') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua') ||
                (this.state.mailingCountry === 'Nicaragua' &&
                  grabPrimaryName(this.state.destination) === 'Nicaragua PKG')
                  ? {
                      ...this.state.allDocuments,
                      ...this.state.allDocuments.documents,
                      passport: { status: 'Not Required Based on Citizenship' },
                      visa: { status: 'No Visa Needed Based on Citizenship' },
                    }
                  : {},
            });
          }
        });
    });
  }

  setHeight = elem => {
    const obj = document.getElementById(elem);
    const objContent = document.getElementById(`${elem}-content`);
    const containerHeight = objContent.offsetHeight;

    obj.style.minHeight = obj.classList.contains('up') ? `${containerHeight + 40}px` : 0;

    scroller(elem);
  };

  setHeightState = elem => {
    const obj = document.getElementById(elem);
    const objContent = document.getElementById(`${elem}-content`);
    const containerHeight = objContent.offsetHeight;

    obj.style.minHeight = `${containerHeight + 40}px`;
  };

  setDocumentsAccordionState = name => {
    this.setState({
      allDocuments: {
        ...this.state.allDocuments,
        [name]: { status: 'Uploaded' },
      },
    });
    this.setState({ [`${name}IsHidden`]: false });
  };

  deactiveActiveAccordion = elem => {
    this.setState({ activeAccordion: '' });
    const obj = document.getElementById(elem);
    obj.style.height = 0;
  };

  isScubaTrip = () => {
    const currentTrip = this.props.user.trips.find(x => x.id === this.state.id);
    if (currentTrip) {
      if (currentTrip.name.toLowerCase().indexOf('scuba') >= 0) {
        return true;
      } else {
        currentTrip.currentAddOns.forEach(addOn => {
          if (addOn.name.toLowerCase().indexOf('scuba') >= 0) {
            return true;
          }
        });
        return false;
      }
    } else {
      return false;
    }
  };

  checkDocumentsAccordionState = () => {
    Auth.currentSession()
      .then(user => {
        this.setState({
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            'Content-Type': 'application/json',
          },
        });
        const options = { headers: this.state.headers };
        API.get('give-api', `/documents/${this.state.id}/`, options)
          .then(() => {
            this.closeModal();
          })
          .catch(() => {
            this.closeModal();
          });
      })
      .catch(() => {});
  };

  openAccordion = itemName => {
    this.setState({
      activeAccordion: this.state.activeAccordion === itemName ? '' : itemName,
    });
  };

  openModal = modalName => {
    this.setState({
      activeModal: modalName,
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  handleRegistrationSubmit = (
    e,
    value,
    registrationHeaderHTML,
    medicalInformationHeaderHTML,
    dietaryRequirementsContentHTML,
    allergiesContentHTML,
    medicalConditionsContentHTML,
    mentalHealthConditionsContentHTML,
    neurodivergentConditionsContentHTML,
    mentalHealthTreatmentContentHTML,
    mentalHealthHospitalizationContentHTML,
    medicalNotesContentHTML,
    medicationsContentHTML,
    medicationConsistencyContentHTML,
    eventOfEmergencyContentHTML,
    registrationContentHTML
  ) => {
    e.preventDefault();

    //TODO: Set loadingbtn: true on TermsAndConditions.js

    Auth.currentSession().then(user => {
      const options = {
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: value,
      };

      options.body.ip = this.state.ip;
      options.body.userId = this.props.user.id;
      options.body.userName = user.idToken.payload.nickname;
      options.body.registrationHeader = registrationHeaderHTML.toString();
      options.body.medicalInformationHeader = medicalInformationHeaderHTML.toString();
      options.body.dietaryRequirementsContent = dietaryRequirementsContentHTML.toString();
      options.body.allergiesContent = allergiesContentHTML.toString();
      options.body.medicalConditionsContent = medicalConditionsContentHTML.toString();
      options.body.mentalHealthConditionsContent = mentalHealthConditionsContentHTML.toString();
      options.body.neurodivergentConditionsContent = neurodivergentConditionsContentHTML.toString();
      options.body.mentalHealthTreatmentContent = mentalHealthTreatmentContentHTML.toString();
      options.body.mentalHealthHospitalizationContent = mentalHealthHospitalizationContentHTML.toString();
      options.body.medicalNotesContent = medicalNotesContentHTML.toString();
      options.body.medicationsContent = medicationsContentHTML.toString();
      options.body.medicationConsistencyContent = medicationConsistencyContentHTML.toString();
      options.body.eventOfEmergencyContent = eventOfEmergencyContentHTML.toString();
      options.body.registrationContent = registrationContentHTML.toString();

      API.post('give-api', `/documents/${this.props.trip.id}/registration`, options)
        .then(response => {
          this.setState({
            user: {
              ...this.props.user,
            },
          });

          this.props.setAppState(this.state.user);
          this.deactiveActiveAccordion('terms-widget');
          this.setDocumentsAccordionState('registration');
          scroller('terms-widget');
          this.closeModal();
        })
        .catch(error => {
          this.setState({
            message: readableResponseMessage(error),
          });
        });
    });
  };

  render() {
    const {
      id,
      allergies,
      dietaryRequirements,
      medicalConditions,
      medicalNotes,
      medications,
      mailingCountry,
      emergencyContact,
      eCPhone,
      eCEmail,
      eCRelationship,
      neurodivergentConditions,
      mentalHealthConditions,
      mentalHealthTreatment,
      mentalHealthHospitalization,
      medicationConsistency,
    } = this.props.user;

    const registrationForm = FormBuilder.group({
      medicalNotes: [medicalNotes ? medicalNotes : '', Validators.required],
      allergies: [allergies ? allergies : '', Validators.required],
      medications: [medications ? medications : '', Validators.required],
      dietaryRequirements: [dietaryRequirements ? dietaryRequirements : '', Validators.required],
      mentalHealthConditions: [
        mentalHealthConditions ? mentalHealthConditions : '',
        Validators.required,
      ],
      neurodivergentConditions: [
        neurodivergentConditions ? neurodivergentConditions : '',
        Validators.required,
      ],
      mentalHealthTreatment: [
        mentalHealthTreatment ? mentalHealthTreatment : '',
        Validators.required,
      ],
      mentalHealthHospitalization: [
        mentalHealthHospitalization ? mentalHealthHospitalization : '',
        Validators.required,
      ],
      medicalConditions: [medicalConditions ? medicalConditions : '', Validators.required],
      medicationConsistency: [
        medicationConsistency ? medicationConsistency : '',
        Validators.required,
      ],
      initials: ['', Validators.required],
      eSignature: ['', Validators.required],
    });

    const { allDocuments, destination } = this.state;

    let documentCount = 1; // Adding 1 for Emergency Contact

    let completedItems = 0;

    if (emergencyContact && eCPhone && eCEmail && eCRelationship) {
      completedItems += 1;
    }

    const isScubaRequirementsCompleted = () => {
      if (allDocuments && allDocuments.scuba) {
        const _scuba = allDocuments.scuba;
        if (
          _scuba.scubaCertificationLevel !== '' &&
          _scuba.scubaPadiELearningCompleted === true &&
          _scuba.scubaPadiMedicalQuestionnaireCompleted === true &&
          _scuba.scubaPadiMedicalClearanceRequired === 'Yes' &&
          _scuba.scubaPadiMedicalClearanceRequired === 'Yes' &&
          _scuba.scubaPadiMedicalClearanceSent === true &&
          destination.indexOf('Thailand') >= 0 &&
          _scuba.scubaBookingFormFastManta === true
        ) {
          return true;
        } else {
          return false;
        }
      }
    };

    if (this.isScubaTrip()) {
      if (allDocuments && allDocuments.scuba) {
        documentCount += 1;
        if (isScubaRequirementsCompleted) {
          completedItems += 1;
        }
      }
    }

    Object.entries(allDocuments || {}).forEach(document => {
      documentCount += 1;
      if (
        document[1].status === 'Approved' ||
        document[1].status === 'Not Required' ||
        document[1].status === 'Not Required Based on Citizenship' ||
        document[1].status === 'Visa on Arrival' ||
        document[1].status === 'No Visa Needed Based on Citizenship'
      ) {
        completedItems += 1;
      }
    });

    const percentageComplete = Math.round((completedItems / documentCount) * 100);

    const documentStatusHandler = eachDocuments => {
      let documentStatus = '';
      if (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Approved') {
        documentStatus = <span className="icon-container check-mark-icon" />;
      } else if (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Uploaded') {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-pending">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container pending-icon" />
          </div>
        );
      } else if (
        allDocuments[eachDocuments] &&
        allDocuments[eachDocuments].status === 'Not Required Based on Citizenship'
      ) {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-uploaded">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container check-mark-icon" />
          </div>
        );
      } else if (
        allDocuments[eachDocuments] &&
        allDocuments[eachDocuments].status === 'No Visa Needed Based on Citizenship'
      ) {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-uploaded">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container check-mark-icon" />
          </div>
        );
      } else if (
        allDocuments[eachDocuments] &&
        allDocuments[eachDocuments].status === 'Visa on Arrival'
      ) {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-uploaded">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container check-mark-icon" />
          </div>
        );
      } else if (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Declined') {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-warning">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container warning-icon" />
          </div>
        );
      } else if (
        allDocuments[eachDocuments] &&
        allDocuments[eachDocuments].status === 'Late - Submit ASAP'
      ) {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-warning">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container warning-icon" />
          </div>
        );
      } else if (
        allDocuments[eachDocuments] &&
        allDocuments[eachDocuments].status === 'Deadline Extended'
      ) {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-warning">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container warning-icon" />
          </div>
        );
      } else if (
        allDocuments[eachDocuments] &&
        allDocuments[eachDocuments].status === 'Contact GIVE'
      ) {
        documentStatus = (
          <div className="icon-text-container">
            <p className="icon-text-warning">{allDocuments[eachDocuments].status}</p>
            <span className="icon-container contact-give-icon" />
          </div>
        );
      } else {
        documentStatus = <span className="icon-container document-icon" />;
      }
      return documentStatus;
    };

    const scubaStatusHandler = () => {
      if (
        allDocuments.scuba &&
        allDocuments.scuba.status &&
        allDocuments.scuba.status !== 'Uploaded' &&
        allDocuments.scuba.status !== 'Approved'
      ) {
        return (
          <div className="icon-text-container">
            <p className="icon-text-warning">{allDocuments.scuba.status}</p>
            <span className="icon-container contact-give-icon" />
          </div>
        );
      } else if (isScubaRequirementsCompleted()) {
        return <span className="icon-container check-mark-icon" />;
      } else {
        return <span className="icon-container document-icon" />;
      }
    };

    const documentTextColorHandler = eachDocuments => {
      let documentAccordionTextColor = '';
      if (
        (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Declined') ||
        (allDocuments[eachDocuments] &&
          allDocuments[eachDocuments].status === 'Deadline Extended') ||
        (allDocuments[eachDocuments] &&
          allDocuments[eachDocuments].status === 'Late - Submit ASAP') ||
        (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Contact GIVE')
      ) {
        documentAccordionTextColor = 'warning-color';
      } else if (
        (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Uploaded') ||
        (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Approved') ||
        (allDocuments[eachDocuments] &&
          allDocuments[eachDocuments].status === 'Not Required Based on Citizenship') ||
        (allDocuments[eachDocuments] && allDocuments[eachDocuments].status === 'Visa on Arrival') ||
        (allDocuments[eachDocuments] &&
          allDocuments[eachDocuments].status === 'No Visa Needed Based on Citizenship')
      ) {
        documentAccordionTextColor = 'uploaded-color';
      } else {
        documentAccordionTextColor = '';
      }
      return documentAccordionTextColor;
    };

    const scubaTextColorHandler = () => {
      let documentAccordionTextColor = '';
      if (
        (allDocuments.pADIMedicalFormPage1 &&
          allDocuments.pADIMedicalFormPage1.status === 'Declined') ||
        (allDocuments.pADIMedicalFormPage2 &&
          allDocuments.pADIMedicalFormPage2.status === 'Declined') ||
        (allDocuments.scubaLiabilityRelease &&
          allDocuments.scubaLiabilityRelease.status === 'Declined') ||
        (allDocuments.pADIMedicalFormPage1 &&
          allDocuments.pADIMedicalFormPage1.status === 'Late - Submit ASAP') ||
        (allDocuments.pADIMedicalFormPage2 &&
          allDocuments.pADIMedicalFormPage2.status === 'Late - Submit ASAP') ||
        (allDocuments.scubaLiabilityRelease &&
          allDocuments.scubaLiabilityRelease.status === 'Late - Submit ASAP') ||
        (allDocuments.pADIMedicalFormPage1 &&
          allDocuments.pADIMedicalFormPage1.status === 'Contact GIVE') ||
        (allDocuments.pADIMedicalFormPage2 &&
          allDocuments.pADIMedicalFormPage2.status === 'Contact GIVE') ||
        (allDocuments.scubaLiabilityRelease &&
          allDocuments.scubaLiabilityRelease.status === 'Contact GIVE')
      ) {
        documentAccordionTextColor = 'warning-color';
      } else if (
        (allDocuments.pADIMedicalFormPage1 &&
          allDocuments.pADIMedicalFormPage1.status &&
          allDocuments.pADIMedicalFormPage2 &&
          allDocuments.pADIMedicalFormPage2.status &&
          allDocuments.scubaLiabilityRelease &&
          allDocuments.scubaLiabilityRelease.status === 'Uploaded') ||
        (allDocuments.pADIMedicalFormPage1 &&
          allDocuments.pADIMedicalFormPage1.status &&
          allDocuments.pADIMedicalFormPage2 &&
          allDocuments.pADIMedicalFormPage2.status &&
          allDocuments.scubaLiabilityRelease &&
          allDocuments.scubaLiabilityRelease.status === 'Approved')
      ) {
        documentAccordionTextColor = 'uploaded-color';
      } else {
        documentAccordionTextColor = '';
      }
      return documentAccordionTextColor;
    };

    return !this.state.allDocuments ? (
      <div className="loader throbber" />
    ) : (
      <div className="documents-accordion">
        <h3 className="h1-style muted margin-bottom-text">Your Trip Checklist</h3>
        <div className="status-bar">
          <div className="percentage-complete" style={{ width: `${percentageComplete}%` }}>
            {percentageComplete > 0 ? `${percentageComplete}% There!` : "Let's get started!"}
          </div>
        </div>
        <h4 id="required-documents" className="darker">
          Please complete the required documents below:
        </h4>
        <div className="accordionClickable styled-container">
          <ul className="tab-bar accordion">
            {!this.props.user.birthdate ||
            !this.props.user.nationality ||
            !this.props.user.citizenship ||
            !this.props.user.gender ||
            !this.props.user.genderIdentity ||
            !this.props.user.pronouns ||
            !this.props.user.shirtSize ? (
              <li className={this.state.additionalInformationIsHidden ? 'hidden' : ''}>
                <button
                  className="clickable warning-color"
                  onClick={() => {
                    this.openAccordion('additionalInformation');
                    this.setHeight('additionalInformation-widget');
                  }}
                >
                  Additional Information
                  <div className="icon-text-container">
                    <p className="icon-text-warning">Submit ASAP</p>
                    <span className="icon-container warning-icon" />
                  </div>
                </button>
                <div
                  id="additionalInformation-widget"
                  className={`form-widget ${
                    this.state.activeAccordion === 'additionalInformation' ? 'down' : 'up'
                  }`}
                >
                  <div id="additionalInformation-widget-content">
                    <AdditionalInformation
                      user={this.props.user}
                      userProps={this.props.userProps}
                      setAppState={this.props.setAppState}
                      deactiveActiveAccordion={this.deactiveActiveAccordion}
                    />
                  </div>
                </div>
              </li>
            ) : (
              ''
            )}
            <li className={this.state.passportIsHidden ? 'hidden' : ''}>
              <button
                className={`clickable ${documentTextColorHandler('passport')}`}
                onClick={() => {
                  this.openAccordion('passport');
                  this.setHeight('passport-widget');
                }}
                disabled={
                  this.state.allDocuments &&
                  this.state.allDocuments.passport &&
                  this.state.allDocuments.passport.status === 'Not Required Based on Citizenship'
                }
              >
                Passport
                {documentStatusHandler('passport')}
              </button>
              <div
                id="passport-widget"
                className={`form-widget ${
                  this.state.activeAccordion === 'passport' ? 'down' : 'up'
                }`}
              >
                <div id="passport-widget-content">
                  <Passport
                    mailingCountry={mailingCountry}
                    endDate={this.state.endDate ? this.state.endDate : ''}
                    userId={id}
                    tripId={this.state.id}
                    destination={this.state.destination}
                    passport={
                      this.state.allDocuments.passport ? this.state.allDocuments.passport : {}
                    }
                    openModal={() => this.openModal('PassportModal')}
                    closeModal={() => this.closeModal}
                    setDocumentsAccordionState={this.setDocumentsAccordionState}
                    setHeightState={this.setHeightState}
                    deactiveActiveAccordion={this.deactiveActiveAccordion}
                  />
                </div>
              </div>
            </li>
            <li className={this.state.visaIsHidden ? 'hidden' : ''}>
              <button
                className={`clickable ${documentTextColorHandler('visa')}`}
                onClick={() => {
                  this.openAccordion('visa');
                  this.setHeight('visa-widget');
                }}
                disabled={
                  this.state.allDocuments &&
                  this.state.allDocuments.visa &&
                  this.state.allDocuments.visa.status === 'No Visa Needed Based on Citizenship'
                }
              >
                Visa
                {documentStatusHandler('visa')}
              </button>
              <div
                id="visa-widget"
                className={`form-widget ${this.state.activeAccordion === 'visa' ? 'down' : 'up'}`}
              >
                <div id="visa-widget-content">
                  <Visa
                    userId={id}
                    destination={this.state.destination}
                    mailingCountry={mailingCountry}
                    tripId={this.state.id}
                    openModal={() => this.openModal('visaChecklistModal')}
                    closeModal={() => this.closeModal}
                    visa={this.state.allDocuments.visa ? this.state.allDocuments.visa : {}}
                    setDocumentsAccordionState={this.setDocumentsAccordionState}
                    deactiveActiveAccordion={this.deactiveActiveAccordion}
                  />
                </div>
              </div>
            </li>
            <li className={this.state.itineraryIsHidden ? 'hidden' : ''}>
              <button
                className={`clickable ${documentTextColorHandler('itinerary')}`}
                onClick={() => {
                  this.openAccordion('itinerary');
                  this.setHeight('itinerary-widget');
                }}
              >
                Flight Itinerary
                {documentStatusHandler('itinerary')}
              </button>
              <div
                id="itinerary-widget"
                className={`form-widget ${
                  this.state.activeAccordion === 'itinerary' ? 'down' : 'up'
                }`}
              >
                <div id="itinerary-widget-content">
                  <Itinerary
                    userId={id}
                    tripId={this.state.id}
                    destination={this.state.destination}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    mailingCountry={this.props.user.mailingCountry}
                    itinerary={
                      this.state.allDocuments.itinerary ? this.state.allDocuments.itinerary : {}
                    }
                    flightStatus={this.state.flightStatus}
                    openModal={() => this.openModal('itineraryModal')}
                    closeModal={() => this.closeModal}
                    setDocumentsAccordionState={this.setDocumentsAccordionState}
                    deactiveActiveAccordion={this.deactiveActiveAccordion}
                  />
                </div>
              </div>
            </li>
            <li className={this.state.insuranceIsHidden ? 'hidden' : ''}>
              <button
                className={`clickable ${documentTextColorHandler('insurance')}`}
                onClick={() => {
                  this.openAccordion('insurance');
                  this.setHeight('insurance-widget');
                }}
              >
                Insurance {documentStatusHandler('insurance')}
              </button>
              <div
                id="insurance-widget"
                className={`form-widget ${
                  this.state.activeAccordion === 'insurance' ? 'down' : 'up'
                }`}
              >
                <div id="insurance-widget-content">
                  <Insurance
                    userId={id}
                    tripId={this.state.id}
                    trip={this.props.trip}
                    mailingCountry={mailingCountry}
                    insurance={
                      this.state.allDocuments.insurance ? this.state.allDocuments.insurance : {}
                    }
                    openModal={() => this.openModal('insuranceModal')}
                    closeModal={() => this.closeModal}
                    setDocumentsAccordionState={this.setDocumentsAccordionState}
                    deactiveActiveAccordion={this.deactiveActiveAccordion}
                  />
                </div>
              </div>
            </li>
            <li
              className={
                this.state.emergencyContactState && this.state.toggleEmergencyContact
                  ? 'hidden'
                  : ''
              }
            >
              <button
                className={`clickable ${
                  emergencyContact && eCPhone && eCEmail && eCRelationship ? 'uploaded-color' : ''
                }`}
                onClick={() => {
                  this.openAccordion('emergencyContact');
                  this.setHeight('emergencyContact-widget');
                }}
              >
                Emergency Contact{' '}
                <span
                  className={`${
                    emergencyContact && eCPhone && eCEmail && eCRelationship
                      ? 'icon-container check-mark-icon'
                      : 'icon-container document-icon'
                  }`}
                />
              </button>
              <div
                id="emergencyContact-widget"
                className={`form-widget ${
                  this.state.activeAccordion === 'emergencyContact' ? 'down' : 'up'
                }`}
              >
                <div id="emergencyContact-widget-content">
                  <EmergencyContact
                    user={this.props.user}
                    setAppState={this.props.setAppState}
                    deactiveActiveAccordion={this.deactiveActiveAccordion}
                  />
                </div>
              </div>
            </li>

            <li className={this.state.termsIsHidden ? 'hidden' : ''}>
              <button
                className={`clickable ${documentTextColorHandler('registration')}`}
                onClick={() => {
                  if (this.state.allDocuments.registration) {
                    this.openAccordion('terms');
                    this.setHeight('terms-widget');
                  } else {
                    this.openModal('termsAndConditionsModal');
                  }
                }}
              >
                Registration {documentStatusHandler('registration')}
              </button>
              <div
                id="terms-widget"
                className={`form-widget ${this.state.activeAccordion === 'terms' ? 'down' : 'up'}`}
              >
                <div id="terms-widget-content">
                  <TermsAndConditions
                    openModal={() => this.openModal('termsAndConditionsModal')}
                    closeModal={() => this.closeModal}
                    registration={
                      this.state.allDocuments.registration
                        ? this.state.allDocuments.registration
                        : {}
                    }
                  />
                </div>
              </div>
            </li>
            {this.isScubaTrip() ? (
              <li className={this.state.padiScuba ? 'hidden' : ''}>
                <button
                  className={`clickable ${scubaTextColorHandler('')}`}
                  onClick={() => {
                    this.openAccordion('padiScuba');
                    this.setHeight('padiScuba-widget');
                  }}
                >
                  Padi Scuba {scubaStatusHandler()}
                </button>
                <div
                  id="padiScuba-widget"
                  className={`form-widget ${
                    this.state.activeAccordion === 'padiScuba' ? 'down' : 'up'
                  }`}
                >
                  <div id="padiScuba-widget-content">
                    <PadiScuba
                      pADIMedicalFormPage1={
                        this.state.allDocuments.pADIMedicalFormPage1
                          ? this.state.allDocuments.pADIMedicalFormPage1
                          : {}
                      }
                      pADIMedicalFormPage2={
                        this.state.allDocuments.pADIMedicalFormPage2
                          ? this.state.allDocuments.pADIMedicalFormPage2
                          : {}
                      }
                      scubaLiabilityRelease={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaLiabilityRelease
                          ? this.state.allDocuments.scuba.scubaLiabilityRelease
                          : {}
                      }
                      scubaBookingFormFastManta={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaBookingFormFastManta
                          ? this.state.allDocuments.scuba.scubaBookingFormFastManta
                          : ''
                      }
                      scubaCertificationLevel={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaCertificationLevel
                          ? this.state.allDocuments.scuba.scubaCertificationLevel
                          : ''
                      }
                      scubaCertificationLevelNotes={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaCertificationLevelNotes
                          ? this.state.allDocuments.scuba.scubaCertificationLevelNotes
                          : ''
                      }
                      scubaPadiELearningCompleted={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaPadiELearningCompleted
                          ? this.state.allDocuments.scuba.scubaPadiELearningCompleted
                          : ''
                      }
                      scubaPadiMedicalClearanceRequired={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaPadiMedicalClearanceRequired
                          ? this.state.allDocuments.scuba.scubaPadiMedicalClearanceRequired
                          : ''
                      }
                      scubaPadiMedicalClearanceSent={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaPadiMedicalClearanceSent
                          ? this.state.allDocuments.scuba.scubaPadiMedicalClearanceSent
                          : ''
                      }
                      scubaPadiMedicalQuestionnaireCompleted={
                        this.state.allDocuments.scuba &&
                        this.state.allDocuments.scuba.scubaPadiMedicalQuestionnaireCompleted
                          ? this.state.allDocuments.scuba.scubaPadiMedicalQuestionnaireCompleted
                          : ''
                      }
                      userId={id}
                      tripId={this.state.id}
                      destination={this.state.destination}
                      setDocumentsAccordionState={this.setDocumentsAccordionState}
                      openModal={() => this.openModal('ScubaModal')}
                      closeModal={() => this.closeModal}
                      deactiveActiveAccordion={this.deactiveActiveAccordion}
                    />
                  </div>
                </div>
              </li>
            ) : (
              ''
            )}
          </ul>
        </div>
        <Modal
          isOpen={this.state.activeModal === 'termsAndConditionsModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <TermsAndConditionsModal
            closeModal={this.closeModal}
            userId={id}
            tripId={this.state.id}
            destination={this.state.destination}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            documentId={this.state.termsDocumentId}
            checkDocumentsAccordionState={this.checkDocumentsAccordionState}
            handleRegistrationSubmit={this.handleRegistrationSubmit}
            registrationForm={registrationForm}
            // TODO: Add all functions to the T&C modal
            // dietaryRequirements={dietaryRequirements || ""}
            // allergies={allergies || ""}
            // medicalConditions={medicalConditions || ""}
            // mentalHealthConditions={mentalHealthConditions || ""}
            // neurodivergentConditions={neurodivergentConditions || ""}
            // mentalHealthTreatment={mentalHealthTreatment || ""}
            // mentalHealthHospitalization={mentalHealthHospitalization || ""}
            // medicalNotes={medicalNotes || ""}
            // medications={medications || ""}
            // medicationConsistency={medicationConsistency || ""}
          />
        </Modal>

        <Modal
          isOpen={this.state.activeModal === 'releaseLiabiltyModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <LiabilityModal
            closeModal={this.closeModal}
            userId={id}
            tripId={this.state.id}
            documentId={this.state.liabilityDocumentId}
            checkDocumentsAccordionState={this.checkDocumentsAccordionState}
          />
        </Modal>
        <Modal
          isOpen={this.state.activeModal === 'itineraryModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <ItineraryModal mailingCountry={mailingCountry} closeModal={this.closeModal} />
        </Modal>

        <Modal
          isOpen={this.state.activeModal === 'insuranceModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <InsuranceModal mailingCountry={mailingCountry} closeModal={this.closeModal} />
        </Modal>

        <Modal
          isOpen={this.state.activeModal === 'visaChecklistModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <VisaChecklistModal mailingCountry={mailingCountry} closeModal={this.closeModal} />
        </Modal>

        <Modal
          isOpen={this.state.activeModal === 'PassportModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <PassportModal closeModal={this.closeModal} />
        </Modal>

        <Modal
          isOpen={this.state.activeModal === 'ScubaModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <ScubaModal closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

DocumentsAccordion.propTypes = {
  setAppState: PropTypes.func,
  hasUploadedAllDocuments: PropTypes.func.isRequired,
  trip: PropTypes.shape({
    id: PropTypes.string,
    destination: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    documents: PropTypes.shape({
      percentageComplete: PropTypes.number,
    }),
  }).isRequired,
  userProps: PropTypes.shape({
    birthdate: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string,
  }),
};

DocumentsAccordion.defaultProps = {
  setAppState: () => {},
  userProps: {},
};
